import { Component, OnInit, TemplateRef } from '@angular/core';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { NotaCredito } from '../../../models/nota-credito';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { ConfigService } from '../../../config/config-service';
import { ReporteModalComponent } from '../../../components/modals/reporte-modal/reporte-modal.component';
import { ReenviarCorreoComponent } from '../../../components/modals/reenviar-correo/reenviar-correo.component';
import { NotacreditoModalComponent } from '../../../components/modals/notacredito-modal/notacredito-modal.component';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { environment } from '../../../../environments/environment';
import { Pagination } from '../../../models/pagination';
import * as moment from 'moment';
import { VentaModalComponent } from '../../modals/venta-modal/venta-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { AsientoContableDetalleModalComponent } from '../../modals/asiento-contable-modal/asiento-contable-detalle-modal.component';

@Component({
  selector: 'app-nota-credito-list',
  templateUrl: './nota-credito-list.component.html',
  styleUrls: ['./nota-credito-list.component.css'],
  providers: [NotaCreditoService, ParametroService]
})
export class NotaCreditoListComponent implements OnInit {
	public notas: Array<NotaCredito>;
	public loading: boolean = false;
	public bsModalRef: BsModalRef;
	public nota : NotaCredito;
	public bsModalRef2: BsModalRef;
	public msg: SweetMessage;
	public Mod_FactElec: string;
	public config: ConfigService;
	public nota_credito_anulada: NotaCredito;
	public observacion: String;
	public factelec_api: String;
	public pagination: Pagination;
	public fecha_emision;
	public numero_decimales: number;
  	public format_decimal: String;
	public Mod_Contabilidad: string;
	constructor(
		private notaCreditoService: NotaCreditoService,
		private modalService: BsModalService,
		private ss: SessionService,
		private parametroService: ParametroService,
	) {
		this.notas = [];
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.config = new ConfigService();
		this.factelec_api = environment.factelec_api;
		this.pagination = new Pagination();
		this.fecha_emision = moment(this.fecha_emision);
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
	}

	ngOnInit() {
		this.msg = new SweetMessage();
		let p1 = this.getNotasCredito();
		Promise.all([p1]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getNotasCredito(){
		return new Promise((resolve, reject) => {
				// let qs="?page=" + this.pagination.current_page + "&per_page=10";
				let usuario_id = this.ss.getData('usuario_id');
				let fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
				let qs = "&fecha_emision=" + fecha_emision + "&usuario_id=" + usuario_id + "&tipo=V";
				this.notaCreditoService.getAll("?embed=tipocomprobante,asientocontable,estadobitacora,venta?embed=cliente" + qs).subscribe(
					res => {
						this.notas = res.data;
						// this.pagination.current_page = res.current_page;
						// this.pagination.from = res.from;
						// this.pagination.to = res.to;
						// this.pagination.total = res.total;
						// this.pagination.last_page = res.last_page;
						// this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
						// this.pagination.prev_disabled = this.pagination.current_page === 1;
						resolve();
					},
					err => {
						this.notas = [];
						reject();
					}
				);
			
			
			
		});
	}

	isAnulable(nota: NotaCredito){

		return true;
	}

	getParamNumeroDecimales(){
		return new Promise((resolve, reject) => {
		  let numero_decimales = 19;
		  this.parametroService.getById(numero_decimales).subscribe(
			res => {
			  this.numero_decimales = res.valor;
	
			  let digitos = "";
			  for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
			  this.format_decimal = "0,0." + digitos
			  resolve();
			},
			err => {
			  this.numero_decimales = 2;
			  this.format_decimal = "0,0.00"
			  reject(err);
			}
		  );
		}); 
	}

	getNumero(nota_credito: NotaCredito){
		return nota_credito.serie + "-" + nota_credito.punto_emision + "-" + nota_credito.secuencial;
	}
	getNumeroVenta(nota_credito: NotaCredito){
		return nota_credito.venta.serie + "-" + nota_credito.venta.punto_emision + "-" + nota_credito.venta.secuencial;
	}

	onShow(id){
		const initialState = {nota_credito_id: id};
		this.bsModalRef = this.modalService.show(NotacreditoModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onShowVenta(id){
		const initialState = {venta_id: id, numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(VentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onShowAsiento(asiento){
		const initialState = {asiento_id: asiento.id, tipo_transaccion_contabilidad_id: asiento.tipo_transaccion_contabilidad_id};
		this.bsModalRef = this.modalService.show(AsientoContableDetalleModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  	}

	onPrint(id){
		/*const initialState = {nota_credito_id: id};
		this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));*/
	}

	onStatusElectronica(nota_credito){
		let msn = "";
		msn += "<p>Estado de nota de crédito electrónica</p>";
        msn += "<p><b style='font-size:24px;'>"+nota_credito.estadobitacora.descripcion+"</b></p>";
    
        this.msg.showMessage('single-message', msn);
	}

	OnReenviar(nota_credito){
        const initialState = { nombre: nota_credito.venta.cliente.nombre_comercial, correo: nota_credito.venta.cliente.correo, autorizacion: nota_credito.numero_autorizacion };
		this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
    }

	onReport(nota_credito){
        const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + nota_credito.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onXML(nota_credito){
		const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + nota_credito.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	CodEst(nota_credito){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === nota_credito.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === nota_credito.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === nota_credito.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
	}

	openModalObservacion(template: TemplateRef<any>, nota_credito: NotaCredito) {
		if(nota_credito.tipo_comprobante_id.toString() === "9" && this.isAnulable(nota_credito) ){
			let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
			const initialState = { Pregunta: preg, Respuesta:false };
			this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
			
			this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
				if(Respuesta == true){
					this.observacion = nota_credito.observacion;
					this.nota_credito_anulada = nota_credito;
					this.bsModalRef = this.modalService.show(template);
					this.bsModalRef2 = this.bsModalRef;
				}
			});
		}
		else{
			this.observacion = nota_credito.observacion;
			this.nota_credito_anulada = nota_credito;
			this.bsModalRef = this.modalService.show(template);
			this.bsModalRef2 = this.bsModalRef;
		}
	}

	anularNota(){
		this.bsModalRef2.hide();
		let preg = "¿Esta seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.nota_credito_anulada.observacion = this.observacion.toString().trim();
				this.nota_credito_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";

				this.loading = true;

				this.notaCreditoService.anular(this.nota_credito_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.nota_credito_anulada = new NotaCredito();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getNotasCredito().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/nota-credito-list/nota-credito-list.component.ts